import React from "react";

import PreBox from "./PreBox";
import ButtonWithPopoverFeedback from "./ButtonWithPopoverFeedback";
import { IconCopy } from "@tabler/icons-react";

const TextDisplayWithCopyToClipboard = ({ label, value, ...rest }) => {
	return (
		<div {...rest}>
			<div className="InputLabel">{label}</div>
			<div style={{ display: "flex", alignItems: "flex-start" }}>
				<PreBox style={{ marginRight: 8, flex: 1 }}>{value}</PreBox>
				<ButtonWithPopoverFeedback
					onClick={() => navigator.clipboard.writeText(value)}
					feedbackMessage="Copied to clipboard!"
					title="Copy"
					iconComponent={<IconCopy size={16} />}
					style={{ marginTop: 6 }}
				/>
			</div>
		</div>
	);
};

export default TextDisplayWithCopyToClipboard;
